import React from "react";
import Divider from "@mui/material/Divider";
import LogoCollection from "./LogoCollection";
import Hero from "./Hero";
import Highlights from "./Highlights";
import Pricing from "./Pricing";
import Features from "./Features";
import Testimonials from "./Testimonials";
import FAQ from "./FAQ";

export default function Home() {
  return (
    <div>
      <Hero />
      {/* <LogoCollection /> */}
      <Pricing />
      <Features />
      <Divider />
      <Testimonials />
      <Divider />
      <Highlights />
      <Divider />
      <Divider />
      {/* <FAQ /> */}
      <Divider />
    </div>
  );
}
